import CartOptionModel from "@/models/CartOptionModel";
import CartItemModel from "@/models/CartItemModel";
import { forEach, map, mapKeys, find, flatMapDeep, cloneDeep, mergeWith, remove, uniqWith, findIndex, } from 'lodash';
import OptionModel from "./OptionModel";
import CartOptionChoiceModel from "./CartOptionChoiceModel";
var RecentItemModel = /** @class */ (function () {
    function RecentItemModel(data) {
        this.id = data.asset_id || data.id;
        this.parentGroupId = data.bundle_group_id || data.parentGroupId || 0;
        this.restoreSiblingOptions = data.sibling_options || data.options || [];
        var i = 0;
        this.restoreSiblingOptions = mapKeys(this.restoreSiblingOptions, function (value, key) {
            return ++i;
        });
        this.restoreSiblings = data.siblings || [];
        this.originalItem = new CartItemModel(data);
    }
    RecentItemModel.prototype.restore = function (menuItem, menuItemOptions, menuItemOptionException) {
        if (!menuItem) {
            return this.originalItem;
        }
        var cartItem = new CartItemModel(menuItem);
        var item = this.originalItem;
        item = mergeWith(item, cartItem, this.mergeEmpty);
        item.siblings = [];
        item.options = this.restoreOptions(menuItemOptions, menuItemOptionException);
        return item;
    };
    RecentItemModel.prototype.mergeEmpty = function (sourceValue, newValue) {
        if (sourceValue !== 0 && !sourceValue) {
            return newValue;
        }
        return sourceValue;
    };
    RecentItemModel.prototype.restoreChoices = function (option, menuOption, menuOptionException, masterChoiceKey) {
        var _this = this;
        if (menuOptionException === void 0) { menuOptionException = null; }
        var choices = option.choices;
        if (!menuOption) {
            return option;
        }
        var menuChoices = menuOption.choices;
        option.choices = map(choices, function (choice) {
            var clonedChoice = cloneDeep(choice);
            var menuOptionChoice = find(menuChoices, function (menuChoice) {
                return clonedChoice.choice_id === menuChoice.id;
            });
            if (!menuOptionChoice) {
                menuOptionChoice = {
                    basePriceDelta: 0,
                    priceDelta: choice.priceDelta,
                };
            }
            var defaultUsed = false;
            // If we have exception, get current store pricing
            if (menuOptionException) {
                // use master option if option matches or use the options mapping
                var isMasterExceptionId = (menuOptionException.id === option.id);
                var focusedMasterOptionException = isMasterExceptionId ? menuOptionException.masterOption : menuOptionException.options[option.id];
                if (focusedMasterOptionException) {
                    var foundChoice = focusedMasterOptionException.getChoice(masterChoiceKey + "-" + choice.choice_id);
                    if (!foundChoice) {
                        foundChoice = focusedMasterOptionException.getDefaultChoice(masterChoiceKey + "-");
                        clonedChoice.price_delta = foundChoice.priceDelta;
                        defaultUsed = true;
                    }
                    else {
                        if (foundChoice.priceDelta) {
                            clonedChoice.price_delta = foundChoice.priceDelta + menuOptionChoice.basePriceDelta;
                        }
                    }
                }
            }
            else {
                clonedChoice['price'] = menuOptionChoice.priceDelta;
            }
            // quantities are sent back as "0" from server for fractional quantities
            if (clonedChoice.fractional_qty === 1 && 2 <= clonedChoice.max_fractional_qty && clonedChoice.qty == "0") {
                clonedChoice.qty = clonedChoice.fractional_qty / clonedChoice.max_fractional_qty;
            }
            clonedChoice['parentId'] = menuOption.id;
            var restoredChoice = new CartOptionChoiceModel(clonedChoice);
            if (defaultUsed) {
                menuOptionChoice.priceDelta = restoredChoice.price;
                restoredChoice.price = 0;
            }
            if (restoredChoice.userSet && restoredChoice.selected === false) {
                menuOptionChoice.selected = false;
                menuOptionChoice.quantity = 0;
            }
            restoredChoice = mergeWith(restoredChoice, menuOptionChoice, _this.mergeEmpty);
            return restoredChoice;
        });
        return option;
    };
    RecentItemModel.prototype.restoreCartOption = function (option) {
        var choices = cloneDeep(option.choices);
        var cartOption = new CartOptionModel(option);
        cartOption.choices = [];
        forEach(choices, function (choice) {
            var cartChoice = new CartOptionChoiceModel(choice);
            cartOption.choices.push(cartChoice);
        });
        return cartOption;
    };
    RecentItemModel.prototype.restoreCartChoiceSibling = function (firstSideChoices, secondSideChoices) {
        var choices = [];
        forEach(firstSideChoices, function (choice) {
            var otherChoice = find(secondSideChoices, function (findChoice) {
                return findChoice.id === choice.id;
            });
            if (choice.fractionalQuantity && choice.maxFractionalQuantity && choice.quantity === 0) {
                choice.quantity = choice.fractionalQuantity / choice.maxFractionalQuantity;
            }
            if (!otherChoice && choice.quantity > 0) {
                choice.setSibling('1');
                choices.push(choice);
                return;
            }
            // TODO consider sibling quantities
            if (choice.quantity !== otherChoice.quantity && !choice.required) {
                choice.setSibling('1');
            }
            else {
                if (choice.required && !choice.quantity) {
                    choice.quantity = 1;
                }
                choices.push(choice);
                return;
            }
            if (choice.quantity > 0) {
                choices.push(choice);
            }
        });
        forEach(secondSideChoices, function (choice) {
            var otherChoice = find(firstSideChoices, function (findChoice) {
                return findChoice.id === choice.id;
            });
            if (!otherChoice && choice.quantity > 0) {
                choice.setSibling('2');
                choices.push(choice);
                return;
            }
            // TODO consider sibling quantities
            if (choice.quantity !== otherChoice.quantity && !choice.required) {
                choice.setSibling('2');
            }
            if (choice.quantity > 0) {
                choices.push(choice);
            }
        });
        choices = uniqWith(choices, function (choiceA, choiceB) {
            return choiceA.id === choiceB.id;
        });
        return choices;
    };
    RecentItemModel.prototype.restoreOptions = function (menuItemOptions, menuItemOptionException) {
        var _this = this;
        var restoreSiblingOptions = this.restoreSiblingOptions;
        var allOptions = flatMapDeep(restoreSiblingOptions, function (options) {
            return options;
        });
        // used to get the correct pricing on the exceptions for each choice
        var masterChoiceKey = null;
        if (menuItemOptionException) {
            var foundOption = find(allOptions, function (option) {
                var foundOption = option.option_id === menuItemOptionException.id;
                return foundOption;
            });
            masterChoiceKey = (foundOption && foundOption.choices) ? foundOption.choices[0].choice_id : null;
        }
        allOptions = map(allOptions, function (option) {
            var menuItemOption = find(menuItemOptions, function (menuOption) {
                return (option.option_id === menuOption.id);
            });
            if (!menuItemOption) {
                return option;
            }
            var choices = cloneDeep(option.choices);
            var restoredOption = new OptionModel(option);
            restoredOption.choices = choices;
            restoredOption = _this.restoreChoices(restoredOption, menuItemOption, menuItemOptionException, masterChoiceKey);
            menuItemOption.choices = null;
            restoredOption = mergeWith(restoredOption, menuItemOption, _this.mergeEmpty);
            return _this.restoreCartOption(restoredOption);
        });
        // find siblings for option choices
        var firstHalf = [];
        var secondHalf = [];
        var _loop_1 = function () {
            var option = allOptions.shift();
            firstHalf.push(option);
            var secondOption = remove(allOptions, function (findOption) {
                return findOption.id === option.id;
            })[0];
            if (secondOption) {
                secondHalf.push(secondOption);
            }
        };
        while (allOptions.length > 0) {
            _loop_1();
        }
        if (secondHalf.length === 0) {
            return firstHalf;
        }
        var mergedOptions = mergeWith(firstHalf, secondHalf, function (sourceValue, newValue) {
            var firstSideOption = sourceValue;
            var secondSideOption = newValue;
            var optionChoices = _this.restoreCartChoiceSibling(firstSideOption.choices, secondSideOption.choices);
            firstSideOption.choices = optionChoices;
            return firstSideOption;
        });
        var siblingOptionKeys = Object.keys(this.restoreSiblingOptions);
        var maps = {};
        for (var index in siblingOptionKeys) {
            var key = siblingOptionKeys[index];
            var siblingOptions = this.restoreSiblingOptions[key];
            for (var i = 0; i < siblingOptions.length; i++) {
                var option = siblingOptions[i];
                var choices = option.choices;
                for (var j = 0; j < choices.length; j++) {
                    var choice = choices[j];
                    // const quantity = choice.qty || 1;
                    var uniqueKey = option.option_id + "-" + choice.choice_id;
                    if (typeof maps[uniqueKey] !== 'undefined') {
                        maps[uniqueKey] = "0";
                        continue;
                    }
                    maps[uniqueKey] = key;
                }
            }
        }
        if (siblingOptionKeys.length > 1) {
            this.siblingDifferences(mergedOptions, maps);
        }
        var _loop_2 = function (i) {
            var optionId = mergedOptions[i].id;
            var keep = mergedOptions[i].choices.filter(function (_choice) {
                return _choice.parentId === optionId;
            });
            var move = mergedOptions[i].choices.filter(function (_choice) {
                return _choice.parentId !== optionId;
            });
            mergedOptions[i].choices = keep;
            var _loop_3 = function (j) {
                var choice = move[j];
                var optionIndex = findIndex(mergedOptions, function (_option) {
                    return _option.id === choice.parentId;
                });
                if (optionIndex === -1) {
                    return "continue";
                }
                mergedOptions[optionIndex].addChoice(choice);
            };
            for (var j = 0; j < move.length; j++) {
                _loop_3(j);
            }
        };
        for (var i = 0; i < mergedOptions.length; i++) {
            _loop_2(i);
        }
        return mergedOptions;
    };
    RecentItemModel.prototype.siblingDifferences = function (mergedOptions, map) {
        var mapKeys = Object.keys(map);
        var _loop_4 = function (key) {
            var parts = key.split('-');
            var optionId = parts[0];
            var choiceId = parts[1];
            // const qty = parts[2];
            var optionIndex = findIndex(mergedOptions, function (_opt) {
                return _opt.id === optionId;
            });
            var choices = mergedOptions[optionIndex].choices;
            var choiceIndex = findIndex(choices, function (_choice) {
                return _choice.id === choiceId;
            });
            if (choiceIndex === -1) {
                return "continue";
            }
            mergedOptions[optionIndex].choices[choiceIndex].siblingId = map[key];
        };
        for (var _i = 0, mapKeys_1 = mapKeys; _i < mapKeys_1.length; _i++) {
            var key = mapKeys_1[_i];
            _loop_4(key);
        }
    };
    return RecentItemModel;
}());
export default RecentItemModel;



//////////////////
// WEBPACK FOOTER
// ./src/models/RecentItemModel.ts
// module id = etUS
// module chunks = 18